import React, { useEffect, useMemo, useState } from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { BsSun, BsMoonStars } from 'react-icons/bs';
import { navLinks } from '../utils/Data.js';
import { useThemeMode } from '../utils/ThemeContext.js';
import { useActiveSection } from '../utils/useActiveSection.js';
import NavMenu from './layouts/NavMenu.js';

import {
  NavbarContainer,
  NavInner,
  Logo,
  NavLinks,
  NavLink,
  NavCTA,
  ThemeToggle,
  MobileActions,
  MenuIcon,
} from '../styles/Navbar.styled.js';

function Navbar() {
  const [openMenu, setOpenMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { isDark, toggleTheme } = useThemeMode();

  const sectionIds = useMemo(() => navLinks.map((link) => link.href), []);
  const activeSection = useActiveSection(sectionIds);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <NavbarContainer scrolled={scrolled}>
      <NavInner>
        <Logo href="#Home">
          Dev<span>Arsh</span>
        </Logo>

        <NavLinks>
          {navLinks.map((link) => (
            <NavLink
              key={link.id}
              href={`#${link.href}`}
              active={activeSection === link.href}
              aria-current={activeSection === link.href ? 'page' : undefined}
            >
              {link.name}
            </NavLink>
          ))}
          <ThemeToggle onClick={toggleTheme} aria-label="Toggle theme">
            {isDark ? <BsSun /> : <BsMoonStars />}
          </ThemeToggle>
          <NavCTA href="#Contact">Let's Talk</NavCTA>
        </NavLinks>

        <MobileActions>
          <ThemeToggle onClick={toggleTheme} aria-label="Toggle theme">
            {isDark ? <BsSun /> : <BsMoonStars />}
          </ThemeToggle>
          <MenuIcon onClick={() => setOpenMenu(true)} aria-label="Open menu">
            <GiHamburgerMenu />
          </MenuIcon>
        </MobileActions>
      </NavInner>

      {openMenu && (
        <NavMenu setOpenMenu={setOpenMenu} activeSection={activeSection} />
      )}
    </NavbarContainer>
  );
}

export default Navbar;
